import React, { useContext, useEffect, useState } from "react";
import { Toast } from "antd-mobile";
import PsContext from "../../context";
import Header from "../header";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";
import { Button, Col, Form, Row, Card } from "react-bootstrap";
import { Spin } from "antd";
import { momentDate } from "../../utils";
import PrintSalarySlip from "./printSalarySlip";
const PaySlip = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [selectedMonthYear, setSelectedMonthYear] = useState("");
  const [datapayslip, setDatapayslip] = useState(false);
  const [dataviewpayslip, setDataViewpaySlip] = useState(false);
  const [setupData, setSetupData] = useState([]);
  const [setupOutData, setSetupOutData] = useState([]);
  const [printReport, setPrintReport] = useState(false);
  const handleMonthYearChange = (e) => {
    setSelectedMonthYear(e.target.value);
  };

  useEffect(() => {
    getReport();
  }, []);

  const getReport = (year = false, month = false) => {
    setLoader(true);
    setDataList([]);
    const form = new FormData();
    form.append("emp_id", context.user.id);
    if (year) form.append("year", year);
    if (month) form.append("month", month);
    axios.post(ServiceUrl.MOB.EMP_PAYSLIP_LIST, form).then((res) => {
      if (res["data"].status == "1") {
        setDataList(res["data"].data);
      } else {
        Toast.show({ content: res["data"].message || "Error" });
      }
      setLoader(false);
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const [year, month] = selectedMonthYear.split("-");

    getReport(year, month);
  };

  const getPayslip = (emp_id, payslip_month, payslip_year) => {
    setLoader(true);
    const form = new FormData();
    form.append("staff_id", emp_id);
    form.append("month", payslip_month);
    form.append("year", payslip_year);

    axios
      .post(ServiceUrl.MOB.GET_GENERATE_PAYSLIP, form)
      .then((res) => {
        if (res["data"].status == "1") {
          setDatapayslip(res["data"].data);
          setDataViewpaySlip(res["data"].data);
          setSetupData(res["data"].setup);
          setSetupOutData(res["data"].setupout);
          setPrintReport(true);
        } else {
        }
      })
      .catch((error) => {})
      .finally(() => {
        setLoader(false);
      });
  };

  return (
    <>
      <Header backAction={true} title="Pay Slip" />
      <Spin spinning={loader}>
        <div className="">
          <div className="container">
            <section className="top-space pt-0 pb-0">
              <div>
                <div className="container staff">
                  <Card className="mb-2">
                    <Card.Header
                      style={{
                        position: "relative",
                        background: " #fff",
                        paddingTop: "15px",
                      }}
                    >
                      <h6>Pay Slip </h6>
                      <Form noValidate id="frm_add" onSubmit={handleSubmit}>
                        <Row className="mt-2">
                          <Col md={3}>
                            <Form.Control
                              type="month"
                              className="fw-bold text-uppercase mt-2"
                              size="sm"
                              name="month_year"
                              onChange={(e) => handleMonthYearChange(e)}
                              required
                            />
                          </Col>
                          <Col md={2} className="mt-2">
                            {" "}
                            <Button
                              type="submit"
                              variant="primary"
                              className="btn btn-block "
                            >
                              Search
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </Card.Header>
                    <Card.Body className="fs-6">
                      <table style={{ height: "auto" }}>
                        <thead>
                          <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Month</th>
                            <th scope="col">Download</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dataList &&
                            dataList.length > 0 &&
                            dataList.map((item) => (
                              <tr>
                                <td data-label="Name">{item.emp_name}</td>
                                <td data-label="Month">
                                  {" "}
                                  {momentDate(
                                    item.payslip_year +
                                      "-" +
                                      item.payslip_month,
                                    "MMM - YYYY"
                                  )}
                                </td>
                                <td data-label="Download">
                                  <Button
                                    size="md"
                                    variant="transparent"
                                    title="Download"
                                    onClick={() =>
                                      getPayslip(
                                        item.emp_id,
                                        item.payslip_month,
                                        item.payslip_year
                                      )
                                    }
                                  >
                                    <i class="fa-solid fa-file-arrow-down"></i>
                                  </Button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </section>
            <section className="top-space "></section>
          </div>
        </div>
      </Spin>
      {printReport && (
        <PrintSalarySlip
          dataSource={datapayslip}
          dataSourceList={dataviewpayslip}
          setupData={setupData}
          setupOutData={setupOutData}
          context={context}
          onSuccess={(e) => setPrintReport(false)}
        />
      )}
    </>
  );
};
export default PaySlip;
